import React from 'react';
import Grid from '@mui/material/Grid';
import PropsType from 'prop-types';
import CAppComponentCard from 'pages/data/addData/CAppComponentCard';
import AppComponentHeader from '@crema/core/AppComponentHeader';
import AppGridContainer from '@crema/core/AppGridContainer';
import BasicDropZone from './BasicDropZone';
import Matrix from './components/Matrix';
import ExportToExcelButton from '@crema/core/AppExportExeclFile';
import Box from '@mui/material/Box';
import {Typography, Alert, AlertTitle} from '@mui/material';
import {green} from '@mui/material/colors';

const AddDataUI = ({
  fileName,
  isClicked,
  allStatusCount,
  setUploadedFiles,
  functionToRun,
  sendDataLoading,
  messages,
  doneStatusCount,
  errorStatusCount,
  uploadedFiles,
  errorsRows,
  validationError,
  isFileValid,
  uploadProgress,
  uploadStatus,
  uploadMessage,
  isUploadCompleted,
}) => {
  return (
    <>
      <AppComponentHeader
        title='Upload Data'
        description="Upload new data to your database by drag'n'drop files."
      />

      <AppGridContainer>
        <Grid item xs={12}>
          <CAppComponentCard
            title={''}
            sendDataLoading={sendDataLoading}
            functionToRun={functionToRun}
            isFileValid={isFileValid}
            uploadMessage={uploadMessage}
            isUploadCompleted={isUploadCompleted}
            hasFile={uploadedFiles && uploadedFiles.length > 0}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant='body2'
                  sx={{mb: 2, color: 'text.secondary'}}
                >
                  <strong>Required Headers:</strong> Full Name, Phone, Age,
                  E-mail Address, Country, marks, MPC_4, data_source
                </Typography>
                <BasicDropZone
                  key='file-upload-dropzone'
                  setFiles={setUploadedFiles}
                  files={uploadedFiles}
                  isInvalid={!isFileValid}
                />
                {validationError && (
                  <Alert severity='error' sx={{mt: 2}}>
                    <AlertTitle>❌ Invalid File</AlertTitle>
                    <Typography variant='body2' sx={{mb: 1}}>
                      {validationError}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{fontSize: '0.875rem', color: 'text.secondary'}}
                    >
                      Required headers: Full Name, Phone, Age, E-mail Address,
                      Country, marks, MPC_4, data_source
                    </Typography>
                  </Alert>
                )}

                {/* Upload Progress Indicator */}
                {sendDataLoading && uploadStatus && (
                  <Box sx={{mt: 2}}>
                    <Box sx={{display: 'flex', alignItems: 'center', mb: 1}}>
                      <Typography
                        variant='body2'
                        sx={{mr: 2, fontWeight: 'bold'}}
                      >
                        {uploadMessage}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{color: 'text.secondary'}}
                      >
                        {uploadProgress}%
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: '100%',
                        height: 8,
                        backgroundColor: 'grey.200',
                        borderRadius: 4,
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          width: `${uploadProgress}%`,
                          height: '100%',
                          backgroundColor:
                            uploadStatus === 'error'
                              ? 'error.main'
                              : uploadStatus === 'completed'
                              ? 'success.main'
                              : 'primary.main',
                          transition: 'width 0.3s ease-in-out',
                          borderRadius: 4,
                        }}
                      />
                    </Box>
                    {uploadStatus === 'completed' && (
                      <Alert severity='success' sx={{mt: 1}}>
                        <Typography variant='body2'>
                          ✅ Upload completed! Processed {doneStatusCount}{' '}
                          records successfully.
                          {errorStatusCount > 0 &&
                            ` ${errorStatusCount} records had errors.`}
                        </Typography>
                      </Alert>
                    )}
                  </Box>
                )}
              </Grid>
              {isClicked ? (
                <Matrix
                  title={messages['addData.DB']}
                  doneStatusCount={doneStatusCount}
                  errorStatusCount={errorStatusCount}
                  allStatusCount={allStatusCount}
                  messages={messages}
                />
              ) : (
                ''
              )}
              {errorStatusCount > 0 ? (
                <ExportToExcelButton
                  fileName={fileName}
                  json_data={errorsRows}
                />
              ) : isClicked ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    ml: 'auto',
                    mt: '1rem',
                    color: green[500],
                  }}
                >
                  <Typography>Data uploaded successfully!</Typography>
                </Box>
              ) : null}
            </Grid>
          </CAppComponentCard>
        </Grid>
      </AppGridContainer>
    </>
  );
};

AddDataUI.propTypes = {
  setUploadedFiles: PropsType.func.isRequired,
  uploadedFiles: PropsType.array.isRequired,
  functionToRun: PropsType.func.isRequired,
  sendDataLoading: PropsType.bool.isRequired,
  isClicked: PropsType.bool.isRequired,
  messages: PropsType.any,
  doneStatusCount: PropsType.number.isRequired,
  errorStatusCount: PropsType.number.isRequired,
  allStatusCount: PropsType.number.isRequired,
  errorsRows: PropsType.array.isRequired,
  fileName: PropsType.string.isRequired,
  validationError: PropsType.string,
  isFileValid: PropsType.bool,
  uploadProgress: PropsType.number,
  uploadStatus: PropsType.string,
  uploadMessage: PropsType.string,
  isUploadCompleted: PropsType.bool,
};

export default AddDataUI;
